// Configuração de ferramentas de análise e comportamento
export const analyticsConfig = {
  // Microsoft Clarity ID
  // Substitua 'SUA_CHAVE_AQUI' pelo seu ID do Clarity
  clarityId: process.env.REACT_APP_CLARITY_ID || 'SUA_CHAVE_AQUI',

  // Google Analytics ID (GA4 - G-XXXXXXXXXX)
  // Substitua 'SEU_ID_GA4' pelo seu ID do Google Analytics
  gaId: process.env.REACT_APP_GA_ID || 'SEU_ID_GA4',

  // Meta Pixel ID
  // Substitua 'SEU_PIXEL_ID' pelo seu ID do Meta Pixel
  pixelId: process.env.REACT_APP_PIXEL_ID || 'SEU_PIXEL_ID',

  // Mixpanel Token
  // Substitua 'SEU_TOKEN_MIXPANEL' pelo seu Token do Mixpanel
  mixpanelToken: process.env.REACT_APP_MIXPANEL_TOKEN || 'SEU_TOKEN_MIXPANEL'
};
